import type { Product } from '~/interfaces/product';

const getProductVariantCoachingSessionDetails = (product: Product) => {
  const isCoachingSession =
    product?.default_product_variant?.redeemable?.type === 'ProductRedeemables::CoachingSession';
  const coachingSessionProvider = product?.default_product_variant?.redeemable?.provider;

  return {
    isCoachingSession,
    coachingSessionProvider,
    // "cal_com" provider type bookings are not instantly redeemable as the booking is made before purchase
    // when the provider is "null", the redeemable is a "link", thus it is instantly redeemable
    canInstantlyRedeem: coachingSessionProvider === null,
  };
};

export default getProductVariantCoachingSessionDetails;
